import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { FvEmptyIllustrationComponent } from '@fv/ui-kit/components/empty-illustration/empty-illustration.component';
import { FvLoaderComponent } from '@fv/ui-kit/components/loader/loader.component';

import { SystemStatusPageQaKeys } from '../../qa-keys';
import { BannerState } from '../../types/banner-state.enum';
import { BannerView } from '../../types/system-health.types';

@Component({
  selector: 'fv-status-banner',
  standalone: true,
  imports: [FvEmptyIllustrationComponent, FvLoaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './status-banner.component.html',
  styleUrl: './status-banner.component.scss',
})
export class StatusBannerComponent {
  readonly qaKeys = SystemStatusPageQaKeys;

  readonly banner = input.required<BannerView>();

  readonly isLoading = computed(() => this.banner().state === BannerState.Loading);
  readonly isEmpty = computed(() => this.banner().state === BannerState.Empty);
}
